import React from 'react'
import { View, StyleSheet, Text } from 'react-native'

import { ASTROLABE_VERSION } from '../../../../api'
import BrightnessIcon from './BrightnessIcon'

const styles = StyleSheet.create({
  star: {
    flex: 1,
    maxWidth: 18,
    paddingHorizontal: 1,
    paddingVertical: 1,
  },
  mainDesc: {
    paddingHorizontal: 0,
  },
  auxDesc: {
    paddingHorizontal: 0,
  },
  minor: {
    paddingHorizontal: 0,
  },
})

const Star = ({ data, theme, version }) => {
  const { palette } = theme
  let starStyles,
    starDescStyles = null
  let brightColor = palette.auxStar
  switch (data.type) {
    case 'MAIN':
      starStyles = [theme.mainStar]
      starDescStyles = [styles.mainDesc, theme.mainDesc]
      brightColor = palette.mainStar
      break
    case 'AUX':
      starStyles = [theme.auxStar]
      starDescStyles = [styles.mainDesc, theme.auxDesc]
      break
    case 'MINOR':
    default:
      starStyles = [styles.minor, theme.minorStar]
      break
  }
  if (version <= ASTROLABE_VERSION.PREVIEW) {
    starStyles.push({ fontSize: 12 })
  }

  return (
    <View style={styles.star}>
      <Text style={starStyles}>{data.name}</Text>
      {version > ASTROLABE_VERSION.SIMPLE && (
        <>
          <BrightnessIcon brightness={data.brightness} color={brightColor} />
          {data.applyName ? (
            <Text style={starDescStyles}>{data.applyName}</Text>
          ) : null}
        </>
      )}
    </View>
  )
}
export default Star
